import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProfileMin } from 'src/app/profiles/shared/profile-min.model';
import {
  initializedCommitteeMeetingAttendeeDto,
  CommitteeMeetingAttendeeDto,
} from 'src/app/committees/shared/dto/committee-meeting-attendee.dto';
import { CommitteeMeetingAttendeeService } from 'src/app/committees/shared/committee-meeting-attendee.service';
import { NotificationService } from 'src/app/shared';

@Component({
  selector: 'wl-committee-meeting-attendance-guest-add-dialog',
  templateUrl: './committee-meeting-attendance-guest-add-dialog.component.html',
  styleUrls: ['./committee-meeting-attendance-guest-add-dialog.component.less'],
    standalone: false
})
export class CommitteeMeetingAttendanceGuestAddDialogComponent implements OnInit {
  @Input() committeeId: number;
  @Input() meetingId: number;
  @Output() guestAdded = new EventEmitter<CommitteeMeetingAttendeeDto>();

  show: boolean;
  isSaving = false;

  constructor(
    private _committeeMeetingAttendeeService: CommitteeMeetingAttendeeService,
    private _notificationService: NotificationService
  ) {}

  ngOnInit(): void {}

  public open() {
    this.show = true;
  }

  addGuest(profile: ProfileMin) {
    const attendee = initializedCommitteeMeetingAttendeeDto(this.meetingId, this.committeeId, profile.ProfileId);
    this.isSaving = true;
    this._committeeMeetingAttendeeService
      .create(attendee)
      .then(() => {
        this._notificationService.translateSuccess('committees.edit.committee-meetings.attendance.guest-added');
        this.guestAdded.emit(attendee);
        this.close();
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  close() {
    this.show = false;
  }
}
